import React from "react";

const NotFound = () => {
  return (
    <div className="bg-slate-900 w-4/5 mx-auto text-yellow-300 py-20 text-center font-bold rounded-xl text-4xl mt-20">
      <p className="mb-5">OOPS!</p>
      <h1>404: Page Not Found</h1>
    </div>
  );
};

export default NotFound;
<h1>Page Not Found</h1>;
